import { z } from '../zod.js';
import { SETTING_ROWS, SETTING_SCHEMAS } from './rows-settings.js';
/** Every setting, with its schema and default. */
export const SETTINGS = Object.freeze(SETTING_ROWS.map((row) => Object.freeze({ ...row, schema: SETTING_SCHEMAS[row.key] })));
/** The setting keys, in the table's order. */
export const SETTING_KEYS = SETTING_ROWS.map((row) => row.key);
export const SettingKey = z.enum(SETTING_ROWS.map((row) => row.key));
/** The object of every setting: what `settings.get` answers. */
export const SettingsV1 = z.strictObject(SETTING_SCHEMAS);
/** The settings as they read before anything is stored. */
export function defaultSettings() {
    return SettingsV1.parse(Object.fromEntries(SETTING_ROWS.map((row) => [row.key, structuredClone(row.default)])));
}
/** The row of a setting key; throws on an unknown key (the route answers 404 for it). */
export function settingRow(key) {
    const row = SETTINGS.find((r) => r.key === key);
    if (row === undefined)
        throw new RangeError(`unknown setting key "${String(key)}"`);
    return row;
}
//# sourceMappingURL=settings.js.map